/**
 * PRO-1364 — Liste figée (palliatif temporaire) des Sales / TAD pour l'écran de marge dédié.
 *
 * Choix assumé et temporaire : en attendant que les rôles `sales` / `tad` soient exploités
 * proprement en base (comme le statut actif/inactif des TAM, TEC-2815), la population est fournie
 * manuellement ici. À supprimer / remplacer par une requête par rôle lors de cette bascule.
 */
import type { IBloomies } from '@bloomays-lib/types.shared';

/**
 * Sous-ensemble de {@link IBloomies} suffisant pour le sélecteur et l'export.
 * `luccaId` (identifiant paie Lucca) reste inconnu à ce stade — renseigné plus tard si besoin.
 */
export type SalesTadOption = Pick<IBloomies, 'email' | 'firstname' | 'lastname' | 'luccaId'>;

export const SALES_TAD_OPTIONS: SalesTadOption[] = [
  { email: 'ludmila.de-dinechin@bloomays.com', firstname: 'Ludmila', lastname: 'de Dinechin', luccaId: null },
  { email: 'victoria.thys@bloomays.com', firstname: 'Victoria', lastname: 'Thys', luccaId: null },
  { email: 'hippolyte.ollivier@bloomays.com', firstname: 'Hippolyte', lastname: 'Ollivier', luccaId: null },
  { email: 'lara.otero@bloomays.com', firstname: 'Lara', lastname: 'Otero', luccaId: null },
];

export const buildSalesTadOptionLabel = (option: SalesTadOption): string =>
  `${option.firstname} ${option.lastname}`.trim() || option.email;
